"use client";
import React, { useState } from "react";
import dynamic from "next/dynamic";
const MainPoster = dynamic(() => import("@/components/mainposter"));
// const ContactCard = dynamic(() => import('@/components/contact-card'))
// const FloatingInput = dynamic(() => import('@/components/floating-input'))
const FormFilledError = dynamic(() => import("@/components/form-filled-error"));
// import ContactCard from "@/components/contact-card";
// import FloatingInput from "@/components/floating-input";
// import FormFilledError from "@/components/form-filled-error";
import Link from "next/link";
import { SocialDetail } from "@/constants/contactus";
import { Toast, ToastContainer, Button, Form } from "react-bootstrap";
import axiosInstance from "@/axiosInstance";
import CommonBtn from "@/components/buttons/CommonBtn";

export default function ContactUs() {
  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    phone_number: "",
    subject: "",
    message: "",
  });
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({});
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.full_name.trim())
      newErrors.full_name = "Full Name Is Required.";
    if (!formData.phone_number.trim())
      newErrors.phone_number = "Phone No Is Required.";
    else if (!/^\d{10}$/.test(formData.phone_number)) {
      newErrors.phone_number =
        "Invalid phone number format. Must be 10 digits.";
    }
    if (!formData.email.trim()) newErrors.email = "Email Is Required.";
    else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Invalid Email Address.";
    }
    if (!formData.subject.trim()) newErrors.subject = "Subject Is Required.";
    if (!formData.message.trim()) newErrors.message = "Message Is Required.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    // if (
    //   !formData.full_name ||
    //   !formData.email ||
    //   !formData.phone_number ||
    //   !formData.subject ||
    //   !formData.message
    // ) {
    //   setMessage("All fields are required");
    //   setShowSuccessToast(true);
    //   return;
    // }

    const payload = {
      full_name: formData.full_name,
      email: formData.email,
      phone_number: formData.phone_number,
      subject: formData.subject,
      message: formData.message,
    };

    try {
      const response = await axiosInstance.post(
        "/api/website/contact",
        payload
      );

      if (response.data.success) {
        setMessage(response.data.message);
        setShowSuccessToast(true);
        setFormData({
          full_name: "",
          email: "",
          phone_number: "",
          subject: "",
          message: "",
        });
      } else {
        setMessage(response.data.message);
        setShowErrorToast(true);
      }
    } catch (error) {
      setMessage(error.response.data.errors || "An error occurred");
      setShowErrorToast(true);
    }
  };

  return (
    <>
      <ToastContainer
        position="top-end"
        className="p-3"
        style={{
          position: "fixed",
          top: "20px",
          left: "80%",
          transform: "translateX(-50%)",
          zIndex: 9999, // Ensure it stays on top
        }}
      >
        <Toast
          onClose={() => setShowSuccessToast(false)}
          show={showSuccessToast}
          delay={3000}
          autohide
          className="bg-success text-white custom-toast"
        >
          <Toast.Body>{message}</Toast.Body>
        </Toast>
        <Toast
          onClose={() => setShowErrorToast(false)}
          show={showErrorToast}
          delay={3000}
          autohide
          className="bg-danger text-white custom-toast"
        >
          <Toast.Body>{message}</Toast.Body>
        </Toast>
      </ToastContainer>
      {/* ------- Poster Section Start ------- */}
      <MainPoster
        bgimg="/assets/images/contact-us/bg-poster/bg-poster.webp"
        title="Contact Us"
        content="Discover the latest in fashion with Kalindi's new collection, where elegance meets innovation. Our fresh designs feature exquisite patterns, luxurious fabrics, and impeccable craftsmanship, ensuring you stand out on every occasion."
      />
      {/* ------- Poster Section End ------- */}

      {/* ------- Contact Us Section Start ------- */}
      {/* <section className="section-py">
        <div className="container-sub px-3 mx-auto">
          <div className="d-flex flex-column flex-xl-row align-items-start justify-content-center contact-content">
            <div className="flex-grow-1 contact-content-left">
              <div className="grid contact-left-gap">
                <div className="g-col-12 g-col-md-6">
                  <FloatingInput
                    type="text"
                    label="Name"
                    placeholder="Enter Your Name"
                    controlId="floatingInput"
                  />
                </div>

                <div className="g-col-12 g-col-md-6">
                  <FloatingInput
                    type="email"
                    label="E-mail"
                    placeholder="Enter Your E-mail"
                    controlId="floatingInput"
                  />
                </div>

                <div className="g-col-12">
                  <FloatingInput
                    type="text"
                    label="Subject"
                    placeholder="Enter Your Subject"
                    controlId="floatingInput"
                  />
                </div>

                <div className="g-col-12">
                  <FloatingLabel
                    controlId="floatingTextarea2"
                    className="rounded-2 px-6 floating-teaxtarea"
                    label="Message"
                  >
                    <Form.Control
                      as="textarea"
                      //    className="shadow-none outline-none p-3"
                      className="shadow-none outline-none p-3"
                      placeholder="Leave a comment here"
                      style={{ height: "190px" }}
                    />
                  </FloatingLabel>
                </div>

                <div className="g-col-12">
                  <Button
                    variant="link"
                    className=" text-white fs-5 fw-normal text-decoration-none rounded-0 mt-2"
                  >
                    Send Message
                  </Button>
                </div>
              </div>
            </div>
            <div className="flex-shrink-1 contact-content-right">
              <div className="grid contact-right-gap">
                <ContactCard
                  data={contactcontent}
                  className="g-col-12 g-col-md-6 g-col-xl-12"
                />
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <section className="section-py">
        <div className="container-lg mx-auto">
          <div className="grid row-gap-lg-0 column-gap-0 column-gap-lg-4 pb-4 border-bottom contactus-content">
            <div className="g-col-12 g-col-lg-4 text-start text-lg-center">
              <h3 className="fw-medium text-capitalize">Location</h3>
              <address className="mt-2 mt-lg-3 mb-0">
                Dhananjay House, Plot No. 85, Chhatrala Ind Park, Near Kadodara
                Chowkdi, B/h MacDonald, Kadodara, Surat, Gujarat 394325
              </address>
            </div>
            <div className="g-col-12 g-col-lg-4 text-start text-lg-center">
              <h3 className="fw-medium text-capitalize">Location</h3>
              <div className="mt-2 mt-lg-3 d-flex flex-column gap-1">
                <Link
                  className="text-decoration-none"
                  href="mailto:care@thekalindi.com"
                  aria-label="care@thekalindi.com"
                >
                  care@thekalindi.com
                </Link>
                <Link
                  className="text-decoration-none"
                  href="tel:8141261261"
                  aria-label="+91 81412 61261"
                >
                  +91 81412 61261
                </Link>
              </div>
            </div>
            <div className="g-col-12 g-col-lg-4 text-start text-lg-center">
              <h3 className="fw-medium text-capitalize">Social</h3>
              <div className="mt-2 mt-lg-3 d-flex align-items-center justify-content-start justify-content-lg-center gap-3">
                {SocialDetail.map((item, i) => {
                  return (
                    <Link href={item.link} key={i} aria-label={item?.title}>
                      {item.icon}
                    </Link>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="mt-5 pt-2 pt-xxl-4 text-center mx-auto contactus-form-content">
            <h2 className="text-capitalize fw-semibold">Get In Touch</h2>
            <p className="pt-2">
              We collaborate with ambitious brands and people; wed love to build
              something great together.
            </p>
            <Form
              onSubmit={handleSubmit}
              className="mt-4 column-gap-0 column-gap-md-4 grid"
            >
              {/* <div className="mt-4 column-gap-0 column-gap-md-4 grid"> */}
              <div className="g-col-12 g-col-md-4">
                <Form.Control
                  type="text"
                  className=" py-2 px-3 shadow-none border-0"
                  placeholder="Full Name"
                  name="full_name"
                  value={formData.full_name}
                  onChange={handleInputChange}
                />
                {errors.full_name && (
                  <FormFilledError title={errors.full_name} />
                )}
              </div>
              <div className="g-col-12 g-col-md-4">
                <Form.Control
                  type="email"
                  className="py-2 px-3 shadow-none border-0"
                  placeholder="Email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                />
                {errors.email && <FormFilledError title={errors.email} />}
              </div>
              <div className="g-col-12 g-col-md-4">
                <Form.Control
                  type="number"
                  className="py-2 px-3 shadow-none border-0"
                  placeholder="Phone No."
                  name="phone_number"
                  value={formData.phone_number}
                  onChange={handleInputChange}
                />
                {errors.phone_number && (
                  <FormFilledError title={errors.phone_number} />
                )}
              </div>
              <div className="g-col-12">
                <Form.Control
                  type="text"
                  className=" py-2 px-3 shadow-none border-0"
                  placeholder="Subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleInputChange}
                />
                {errors.subject && <FormFilledError title={errors.subject} />}
              </div>
              <div className="g-col-12">
                <Form.Control
                  as="textarea"
                  className="py-2 px-3 shadow-none border-0"
                  placeholder="Leave a comment here"
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                />
                {errors.message && <FormFilledError title={errors.message} />}
              </div>
              <div className="g-col-12 text-center mt-4">
                <CommonBtn type="submit" className="fw-normal">
                  Send Message
                </CommonBtn>
                {/* <Button
                  type="submit"
                  variant="dark"
                  className="text-white fw-normal text-decoration-none rounded-0"
                >
                  Send Message
                </Button> */}
                {errors.form && <FormFilledError title={errors.form} />}
              </div>
              {/* </div> */}
            </Form>
          </div>
        </div>
      </section>
      {/* ------- Contact Us Section End  ------- */}

      {/* ------- Kalindi Location Section Satrt ------- */}
      <section className="position-relative section-py pt-0 kalindi-location-content">
        <div className="container-lg mx-auto">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3720.2917665713553!2d72.95833787587536!3d21.180565482546005!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04e63a5de0acb%3A0x16827f7570270b5d!2sDhananjay%20Creations%20Private%20Limited!5e0!3m2!1sen!2sin!4v1744006192008!5m2!1sen!2sin"
            width="100%"
            height="400"
            allowFullScreen
            loading="lazy"
            className="rounded-2"
            referrerPolicy="no-referrer-when-downgrade"
            title="Map showing location of Dhananjay Creations Private Limited"
          />
        </div>
        {/* <div className=" position-absolute top-0 bottom-0 start-0 end-0 location-layer"></div> */}
      </section>
      {/* ------- Kalindi Location Section End ------- */}
    </>
  );
}
